import { motion } from 'motion/react';

interface HealthDataEditorTitleMobileProps {
  className?: string;
}

export function HealthDataEditorTitleMobile({
  className = '',
}: HealthDataEditorTitleMobileProps) {
  return (
    <motion.div
      className={`flex flex-col gap-[5px] items-start justify-center w-full ${className}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      {/* Title */}
      <motion.h1
        className="font-['Inter'] font-bold text-[25px] leading-[1.3] tracking-[0.2px] text-center text-white w-full"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        Your Health Data
      </motion.h1>

      {/* Description */}
      <motion.p
        className="font-['Inter'] font-normal text-center text-[14px] leading-[1.4] text-white w-full"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.3 }}
      >
        Keep your Health Data up to date so your risk scores and recommendations stay aligned with your life, habits, latest test results, and more.
      </motion.p>
    </motion.div>
  );
}
